export const targetText = {
  pageTitle: 'Target Achievement',
  createButton: 'Create Target',
  uploadButton: 'Upload',
};

export const targetFilterText = {
  brandPlaceholder: 'Pilih Brand',
  appliedDatePlaceholder: 'Pilih Bulan Tahun',
};

export const tableText = {
  actionText: 'Create target',
  columnBrandText: 'Brand',
  columnRevenueText: 'Target Penghasilan',
  columnShopeeTarget: 'Target Shopee',
  columnTiktokTarget: 'Target Tiktok',
};

export const formUpsertText = {
  labelAppliedAt: 'Bulan Tahun',
  placeholderAppliedAt: 'Pilih bulan tahun',
  labelBrandName: 'Brand',
  placeholderBrandName: 'Pilih brand',
  labelTargetIncome: 'Target Penghasilan',
  targetIncomeToolTip: 'Target pencapaian pendapatan brand (GMV)',
  titleTargetShopee: 'Target Shopee',
  titleTargetTiktok: 'Target Tiktok',
  labelTargetViewsShopee: 'Views Shopee',
  labelTargetViewsTiktok: 'Views Tiktok',
  targetViewsToolTip: 'Jumlah tayangan/views aktual yang dicapai',
  labelTargetCtrShopee: 'CTR Shopee',
  labelTargetCtrTiktok: 'CTR Tiktok',
  targetCtrToolTip: 'Nilai Target click-through rate (CTR) adalah persentase frekuensi penonton yang klik tautan produk di live.',
  labelTargetAovShopee: 'AOV Shopee',
  labelTargetAovTiktok: 'AOV Tiktok',
  targetAovToolTip: 'Target pencapaian Average Order Value (AOV) yang merupakan nilai rata rata penghasilan per pesanan.',
  labelTargetCtorShopee: 'CTOR Shopee',
  labelTargetCtorTiktok: 'CTOR Tiktok',
  targetCtorToolTip: 'click-to-order rate (CTOR) adalah persentase frekuensi penonton yang mengklik tautan produk di live dan membuat pesanan .',
  labelTargetErrTiktok: 'ERR Tiktok',
  targetErrToolTip: 'Nilai engagement rate (ERR) adalah persentase orang yang masuk ke live terhadap jumlah orang yang terpapar live (impression).',
  placeholderTargetViews: 'cth. 1000',
  buttonBatal: 'Batal',
  buttonSimpan: 'Simpan',
  cancelConfirmationTitle: 'Yakin ingin membatalkan?',
  cancelConfirmationDesc: 'Perubahan yang telah kamu buat mungkin tidak akan tersimpan. Apakah kamu yakin ingin membatalkan?',
  cancelSubmitButton: 'Ya, batalkan',
  cancelCancelButton: 'Tutup',
  emptyStateTitle: 'Pilih Bulan Terlebih Dahulu',
  emptyStateDesc: 'Detail lainnya akan ditampilkan setelah kamu memilih bulan',
};

export const targetDeleteModalText = {
  title: 'Apakah kamu yakin ingin menghapus target ini?',
  description: 'Tindakan ini tidak bisa dibatalkan, dan semua detail terkait akan hilang.',
  closeButton: 'Batal',
  submitButton: 'Hapus sekarang',
};

export const targetDeleteDomainText = {
  loadingTitle: 'Harap tunggu',
  loadingDescription: 'Sedang menghapus target...',
  successDescrption: 'Target berhasil dihapus',
  errorTitle: 'Gagal menghapus target..',
  errorDescription: 'Terjadi kesalahan saat menghapus target. Silakan coba lagi atau periksa koneksi kamu.',
};

export const targetUpsertCreateDomainText = {
  loadingTitle: 'Harap tunggu',
  loadingDescription: 'Sedang menyimpan target...',
  successDescription: 'Target berhasil dibuat',
  errorTitle: 'Gagal membuat target',
  errorDescription: 'Terjadi kesalahan saat membuat target. Silakan coba lagi atau periksa koneksi kamu.',
};

export const targetUpsertEditDomainText = {
  loadingTitle: 'Harap tunggu',
  loadingDescription: 'Sedang menyimpan target...',
  successDescription: 'Target berhasil diperbarui',
  errorTitle: 'Gagal membuat target',
  errorDescription: 'Terjadi kesalahan saat membuat target. Silakan coba lagi atau periksa koneksi kamu.',
};
